const hiddenMenuItems: string[] = ((window as any).env?.HIDDEN_MENU_ITEMS || "") //HIDDEN_MENU_ITEMS=tools,news
  .split(",")
  .map((item: string) => item.trim())
  .filter((item: string) => item.length > 0);
const hiddenLangs: string[] = ((window as any).env?.HIDDEN_LANGS || "") //HIDDEN_LANGS=ro
    .split(",")
    .map((item: string) => item.trim())
    .filter((item: string) => item.length > 0);

export const environment = {
  production: true,
  baseUrl: (window as any).env?.API_URL || "https://api.cyberquest.fr",
  local: false,
  idp: (window as any).env?.IDP || "https://auth.cyberquest.fr",
  realm: (window as any).env?.REALM || "cyberquest",
  HUB_SESSION_OPENING_DATE: (window as any).env?.HUB_SESSION_OPENING_DATE,
  HUB_SESSION_CLOSING_DATE: (window as any).env
    ?.HUB_SESSION_OPENING_CLOSING_DATE,
  questInstance: (window as any).env?.QUEST_INSTANCE || "cyber",
  hiddenMenuItems,
  hiddenLangs,
};
